import { add } from "./base";
class Handler {
    toString(data) {
        let result = "";
        if (typeof data == "number") {
            const decimals = data.toString().split(".")[1]?.length ?? 2;
            result = (data * 100).toFixed(!decimals || decimals <= 1 ? 0 : decimals - 2);
        }
        return result;
    }
    fromString(value) {
        const parsedFloat = typeof value == "string" ? Number.parseFloat(value) : undefined;
        return typeof parsedFloat == "number" && !Number.isNaN(parsedFloat) ? parsedFloat / 100 : undefined;
    }
    partialFormat = this.format;
    format(unformatted) {
        return {
            ...(unformatted.value ? unformatted.suffix(" %") : unformatted),
            type: "text",
            inputmode: "numeric",
            length: [3, undefined],
            pattern: /^\d+(.\d+)? %+$/,
        };
    }
    unformat(formatted) {
        return formatted.delete(" %");
    }
    allowed(symbol, state) {
        return (symbol >= "0" && symbol <= "9") || (symbol == "." && !state.value.includes("."));
    }
}
add("percent", () => new Handler());
//# sourceMappingURL=percent.js.map